import { createSlice } from '@reduxjs/toolkit';

export interface enrollmentFormState {
	step: number;
	formData: any;
}

const initialState: enrollmentFormState = {
	step: 0,
	formData: {},
};

export const enrollmentFormSlice = createSlice({
	name: 'enrollmentForm',
	initialState,
	reducers: {
		setFormData: (state, { payload }) => {
			state.formData = payload;
		},
		clearForm: (state) => {
			state.step= 0;
			state.formData = {};
		},
		setStep: (state, {payload}) => {
			state.step = payload;
		},
	}
});

export const { setFormData, clearForm, setStep} = enrollmentFormSlice.actions;

export default enrollmentFormSlice.reducer;